import { inject, observer } from 'mobx-react';
import React from 'react';

import Hljs from 'main/components/Hljs';

@inject('scanWizardStore')
@observer
export default class Install extends React.Component {
    getDebianSetup = () => (
        <div>
            <h3>1. Configure repository</h3>
            Add vulners.com pubkey:
            <Hljs language="bash" className="bash">
                wget -O- https://repo.vulners.com/pubkey.txt | apt-key add -
            </Hljs>
            After this create file /etc/apt/sources.list.d/vulners.list
            <Hljs language="bash" className="bash">
                deb http://repo.vulners.com/debian focal main
            </Hljs>
            <br />
            <h3>2. Install packet</h3>
            <Hljs language="bash" className="bash">
                apt-get update && apt-get install vulners-agent
            </Hljs>
        </div>
    );

    getRedhatSetup = () => (
        <div>
            <h3>1. Configure repository</h3>
            Create file <b>/etc/yum.repos.d/vulners.repo</b>
            <h5>For RHEL 6:</h5>
            <Hljs language="bash" className="bash">
                [vulners]
                <br />
                name=Vulners Agent
                <br />
                baseurl=https://repo.vulners.com/redhat/el6/
                <br />
                enabled=1
                <br />
                gpgcheck=1 gpgkey=https://repo.vulners.com/pubkey.txt
            </Hljs>
            <h5>For RHEL 7:</h5>
            <Hljs language="bash" className="bash">
                [vulners]
                <br />
                name=Vulners Agent
                <br />
                baseurl=https://repo.vulners.com/redhat/el7/
                <br />
                enabled=1
                <br />
                gpgcheck=1 gpgkey=https://repo.vulners.com/pubkey.txt
            </Hljs>
            <br />
            <h3>2. Install Package</h3>
            <Hljs language="bash" className="bash">
                yum install vulners-agent
            </Hljs>
        </div>
    );

    render() {
        const { osType } = this.props.scanWizardStore;

        return <div>{osType && (osType === 'debian' ? this.getDebianSetup() : this.getRedhatSetup())}</div>;
    }
}
